export default __webpack_public_path__ + "static/media/glrc-course.garde-manger.6e42efb3.png";